<template>
    <div
        class="modal fade"
        :class="isCloseSale ? 'show d-block' : 'd-none'"
        id="modal-close-sale"
        tabindex="-1"
        aria-labelledby="modal-close-sale"
        aria-modal="true"
        role="dialog"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-24 overflow-hidden">
                <div class="block rounded-24 block-transparent mb-0">
                    <div class="block-header">
                        <h3 class="block-title">Clôturer la vente</h3>
                        <div class="block-options">
                            <button
                                type="button"
                                class="btn-block-option"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                @click="$emit('close-sale-modal')"
                            >
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content fs-sm">
                        <p>Voulez-vous clôturer la vente ?</p>
                        <div v-if="data.send_invoice" id="container_company" class="form-group mb-2">
                            <label class="form-label" for="company_name">Ajouter une société sur la facture</label>
                            <input
                                class="form-control"
                                type="text"
                                name="company_name-modal"
                                id="company_name-modal"
                                v-model="data.company_name"
                            />
                            <div class="d-flex gap-2 w-100 mt-3">
                                <div class="w-100">
                                    <label class="form-label" for="company_address">Adresse</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        name="company_address-modal"
                                        id="company_address-modal"
                                        v-model="data.company_address.address"
                                    />
                                </div>
                                <div class="w-100">
                                    <label class="form-label" for="company_cp">Code postal</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        name="company_cp-modal"
                                        id="company_cp-modal"
                                        v-model="data.company_address.cp"
                                    />
                                </div>
                                <div class="w-100">
                                    <label class="form-label" for="company_country">Pays</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        name="company_country-modal"
                                        id="company_country-modal"
                                        v-model="data.company_address.country"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="data.send_mail" class="mb-2">
                            <label class="form-label">Mail de remerciement</label>
                            <div class="form-check">
                                <input
                                    id="rebooking-modal"
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="data.rebooking"
                                    @change="
                                        event => {
                                            event.target.checked ? (data.rebooking = true) : (data.rebooking = false)
                                        }
                                    "
                                />
                                <label for="rebooking-modal" class="form-label">Offre de rebooking</label>
                            </div>
                            <div class="form-check">
                                <input
                                    id="notice-modal"
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="data.notice"
                                    @change="
                                        event => {
                                            event.target.checked ? (data.notice = true) : (data.notice = false)
                                        }
                                    "
                                />
                                <label for="notice-modal" class="form-label">Liens des avis</label>
                            </div>
                        </div>
                        <div class="d-flex flex-row pb-3">
                            <div class="form-switch p-0 pe-2">
                                <button
                                    type="button"
                                    role="button"
                                    class="btn btn-sm rounded-pill"
                                    :class="data.send_mail ? 'btn-info text-white' : 'btn-outline-info'"
                                    @click="
                                        () => {
                                            data.send_mail = !data.send_mail
                                            if(!data.send_mail) {
                                                data.rebooking = false
                                                data.notice = false
                                            }
                                        }
                                    "
                                    ref="sendMailBtn"
                                >
                                    <i
                                        class="fa fa-xs fa-fw fa-check pe-2"
                                        :class="data.send_mail ? 'd-inline-block' : 'd-none'"
                                        ref="sendMailIcon"
                                    ></i
                                    >Mail de remerciement
                                </button>
                            </div>
                            <div class="form-switch p-0">
                                <button
                                    type="button"
                                    role="button"
                                    class="btn btn-sm rounded-pill"
                                    :class="data.send_invoice ? 'btn-warning text-white' : 'btn-outline-warning'"
                                    @click="
                                        () => {
                                            data.send_invoice = !data.send_invoice
                                            if(!data.send_invoice) {
                                                data.company_name = null
                                                data.company_address = {
                                                    address: null,
                                                    cp: null,
                                                    country: null
                                                }
                                            }
                                        }
                                    "
                                    ref="sendInvoiceBtn"
                                >
                                    <i
                                        class="fa fa-xs fa-fw fa-check pe-2"
                                        :class="data.send_invoice ? 'd-inline-block' : 'd-none'"
                                        ref="sendInvoiceIcon"
                                    ></i
                                    >Facture
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-center">
                        <button
                            type="button"
                            class="btn btn-sm btn-alt-primary text-primary me-1  rounded-pill"
                            data-bs-dismiss="modal"
                            @click="hideModal('encaisser')"
                        >
                            Encaisser seulement
                        </button>
                        <button
                            type="button"
                            class=" btn btn-sm btn-primary text-white rounded-pill"
                            data-bs-dismiss="modal"
                            @click="hideModal('cloturer')"
                        >
                            Clôturer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['closeSaleModal', 'companyName', 'companyAddress', 'sendInvoice', 'sendMail', 'parameterThanks'],
    data: () => ({
        isCloseSale: false,
        data: {
            close_sale: true,
            company_name: null,
            company_address: {
                address: null,
                cp: null,
                country: null,
            },
            rebooking: false,
            notice: false,
            send_mail: false,
            send_invoice: false
        },
    }),
    created() {
        this.data.send_invoice = this.sendInvoice
        this.data.send_mail = this.sendMail
    },
    mounted() {
        this.isCloseSale = this.closeSaleModal
        this.data.company_name = this.companyName
        this.data.company_address = this.companyAddress
        this.data.rebooking = this.parameterThanks.rebooking
        this.data.notice = this.parameterThanks.notice
    },
    methods: {
        hideModal(type = null) {
            if (type == 'encaisser') {
                this.data.close_sale = false
            } else if (type == 'cloturer') {
                this.data.close_sale = true
            }
            this.$emit('close-sale', this.data)

            // this.isCloseSale = !this.isCloseSale
        },
    },
    watch: {
        closeSaleModal(newVal) {
            this.isCloseSale = newVal
        },
    },
}
</script>

<style></style>
